import React from "react";
import { motion } from "framer-motion";
import { Truck, Plane, Car } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../data/content";

const industries = [
  { icon: Truck, img: IMAGES.logistics, tKey: "industry_1" },
  { icon: Plane, img: IMAGES.aviation, tKey: "industry_2" },
  { icon: Car, img: IMAGES.automotive, tKey: "industry_3" },
];

export const Industries = () => {
  const { t } = useLang();
  return (
    <section id="industries" className="relative py-24 lg:py-32" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("industries_eyebrow")}</div>
          <h2 className="font-head font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">{t("industries_title")}</h2>
          <p className="mt-5 text-base text-zinc-400 leading-relaxed">{t("industries_subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {industries.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <motion.div
                key={ind.tKey}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="media-dark group relative rounded-2xl overflow-hidden border border-white/10 h-[420px] card-glow"
                data-testid={`industry-card-${i}`}
              >
                <img src={ind.img} alt={t(`${ind.tKey}_title`)} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#030305] via-[#030305]/40 to-transparent" />
                <div className="absolute bottom-0 p-7">
                  <div className="w-11 h-11 rounded-xl bg-[#00F0FF]/15 border border-[#00F0FF]/40 flex items-center justify-center mb-4 backdrop-blur-md">
                    <Icon size={20} className="text-cyan" />
                  </div>
                  <h3 className="font-head font-semibold text-2xl text-white mb-2">{t(`${ind.tKey}_title`)}</h3>
                  <p className="text-sm text-zinc-300 leading-relaxed">{t(`${ind.tKey}_desc`)}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
